import { notification } from 'antd'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import {
  bonusTransactionListUrl, forexDashboardGraphUrl,
  forexBonusDashboardUrl,
  forexCommissionWithdrawalUrl,
  loadCurrentBalanceUrl, addWithdrawalIssueUrl, getWithdrawalIssues, udpateWithdrawalStatus, updateWithdrawalStatus
} from '../api/commissionApi'


export const forexBonusDashboardFxn = async (valData) => {
  let { data } = await axios.post(
    forexBonusDashboardUrl(),
    valData,
    getToken()
  )
  return data
}

export const bonusTransactionListFxn = async (valData) => {
  let config = {
    params: valData,
    ...await getToken()
  }
  let { data } = await axios.get(bonusTransactionListUrl(), config)
  return data.data
}

export const loadCurrentBalanceFxn = async (valData) => {
  let { data } = await axios.post(
    loadCurrentBalanceUrl(),
    valData,
    getToken()
  )
  return data
}

export const forexCommissionWithdrawalFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(forexCommissionWithdrawalUrl(), valData, getToken())
  dispatch(hidePageLoad())

  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const forexDashboardGraphFxn = async (valData) => {
  let { data } = await axios.post(forexDashboardGraphUrl(), valData, getToken())
  return data
}

export const addWithdrawalIssueFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addWithdrawalIssueUrl(), valData, getToken())
  dispatch(hidePageLoad())

  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const updateWithdrawalIssueStatus = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateWithdrawalStatus(), valData, getToken())
  dispatch(hidePageLoad())

  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const getWithdrawalIssuesFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: valData,
    ...await getToken()
  }
  let { data } = await axios.get(getWithdrawalIssues(), config)
  dispatch(hidePageLoad())
  return data.data
}